import React from "react";
import PropTypes from "prop-types";
import Util from "../../../Util/";

const EmailPhone = (props = {}) => {
  const { email, phone, hideEmail, hidePhone } = props;

  const showEmail = !hideEmail && email?.href && email?.label
  const showPhone = !hidePhone && phone?.href && phone?.label

  return (
    <div className="bux-footer__contact bux-footer__contact--email-phone">
      <hr />
      {showEmail && <p className="bux_footer__email">
        <Util.Link {...email}>
          {email.label}
        </Util.Link>
      </p>}
     {showPhone && <p className="bux_footer__phone">
        <Util.Link id={phone.id} href={phone.href}>
          {phone.label}
        </Util.Link>
      </p>}
    </div>
  );
};
EmailPhone.propTypes = {
  email: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
  phone: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default EmailPhone;
